const API_URL = 'https://cv-api.ctlabs.in';
const GOOGLE_KEYS = 'AIzaSyAJeeYX9zKqxnvTBgB8NpOI4_NIsRPVF8A';

export const CONTACT_DETAILS_URL = `${API_URL}/forms`;
export const VALIDATOR_STATS_URL = `${API_URL}/validator-stats`;
export const YOUTUBE_LIST_URL = `https://www.googleapis.com/youtube/v3/search?key=${GOOGLE_KEYS}&channelId=UCX7kHUiacI6ycHF8Wd8mGmw&part=snippet,id&order=date&maxResults=1`;
